module.exports = __webpack_public_path__ + "static/automation-900a9f7213a75b0e22077acfcae05fb3.mp4";